module.exports = __webpack_public_path__ + "static/media/logo.5288e9a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/fish/logo.png
// module id = 320
// module chunks = 0